import Vue from 'vue';
import VueRouter from 'vue-router';

import HomePage from './pages/Home.vue';
import LaPlagePage from './pages/LaPlage.vue';
import IdentitePage from './pages/Identite.vue';
import AgendaPage from './pages/Agenda.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', component: HomePage },
  { path: '/la-plage', component: LaPlagePage },
  { path: '/identite', component: IdentitePage },
  { path: '/agenda/*', component: AgendaPage },
  { path: '/agenda', component: AgendaPage },
];

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // if (to.hash) {
    //   return {selector: to.hash}
    // } else {
    //   return { x: 0, y: 0 }
    // }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let position = {}

        // scroll to anchor by returning the selector
        if (to.hash) {
          position.selector = to.hash

          // specify offset of the element
          if (to.hash === '#abonnements') {
            position.offset = { y: 160 }
          }

          if (document.querySelector(to.hash)) {
            // return position
          }else{
            position = false
          }
        }else{
          position = { x: 0, y: 1 }
        }

        resolve(position)
      }, 1550)
    })
    
    // return new Promise(resolve => {
    //   // check if any matched route config has meta that requires scrolling to top
    //   if (to.matched.some(m => m.meta.scrollToTop)) {
    //     // coords will be used if no selector is provided,
    //     // or if the selector didn't match any element.
    //     position.x = 0
    //     position.y = 0
    //   }

    //   // wait for the out transition to complete (if necessary)
    //   this.app.$root.$once('triggerScroll', () => {
    //     // if the resolved position is falsy or an empty object,
    //     // will retain current scroll position.
    //     resolve(position)
    //   })
    // })
  },
});

router.onReady(() => {
  // console.log('router ready');
});

export default router;
